export default __webpack_public_path__ + "apply4_159693c.png";